import React from "react";
import { Excel } from "antd-table-saveas-excel";
import { Button } from "antd";
import excelIcon from "../../../../../assets/download_excel_icon.svg";
import {
  deepCopy,
  generateExcelData,
  getUpdatedDataSourceForExcel,
  secondsToDhms,
  separateColumnsAndData,
} from "../../../../../redux/constants";
import { SecondstoHumanReadable } from "../../../../utils/charts/HighCharts/graphFunction";
import { useSelector } from "react-redux";

const DownloadExcel = ({ widgetData, isDeepDive = false }) => {
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const handleExport = () => {
    // console.log("widgetData", widgetData);
    if (widgetData?.widget_id === "000-700-001") {
      let widgetMakerGraphData =
        window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
        window.location.pathname?.split("/")?.[1] === "create-dashboard"
          ? widgetData?.data?.data?.grid
            ? widgetData?.data?.data?.grid
            : widgetData?.data?.data?.[`pivot-grid`]
          : widgetData?.graphData?.data?.grid
          ? widgetData?.graphData?.data?.grid
          : widgetData?.graphData?.data?.[`pivot-grid`];
      const excel = new Excel();
      let columns;
      let updatedDataSource;
      let currentDataSource = widgetMakerGraphData?.[0]?.dataSource?.length
        ? deepCopy(widgetMakerGraphData?.[0]?.dataSource)
        : [];

      columns = widgetMakerGraphData[0]?.columns
        ?.map((e) => {
          return {
            title: e.title,
            dataIndex: e.title,
          };
        })
        ?.filter((el) => el);

      columns = columns?.filter(
        (el) =>
          el?.title !== "Brand ID" &&
          el?.title !== "Brand Name" &&
          el?.title !== "Oldest Tickets in queue" &&
          el?.title !== "Team User ID"
      );

      let avg = [];
      updatedDataSource = currentDataSource?.map((d) => {
        avg.push({
          [`Agent`]: d["Agent"],
          [`Current Status`]:
            d["Current Status"] === 0 ? "Logged In" : "Logged Out",
          [`Status Updated Since`]: secondsToDhms(d["Status Updated Since"])
            ? secondsToDhms(d["Status Updated Since"])
            : 0,
          [`Tickets in queue`]: d["Tickets in queue"],
          [`Unactioned Tickets in queue`]: d["Unactioned Tickets in queue"],
          [`Oldest Ticket Brand`]: d["Oldest Ticket Brand"],
          [`Oldest Ticket Since`]: SecondstoHumanReadable(
            d["Oldest Ticket Since"]
          )
            ? SecondstoHumanReadable(d["Oldest Ticket Since"])
            : 0,
        });
      });

      excel
        .addSheet("test")
        .addColumns(columns)
        .addDataSource(avg, {
          str2Percent: true,
        })
        .saveAs(`${widgetData?.widget_name}.xlsx`);
    } else {
      let widgetMakerGraphData =
        window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
        window.location.pathname?.split("/")?.[1] === "create-dashboard"
          ? widgetData?.data?.data?.grid
            ? widgetData?.data?.data?.grid
            : widgetData?.data?.data?.[`pivot-grid`]
          : widgetData?.graphData?.data?.grid
          ? widgetData?.graphData?.data?.grid
          : widgetData?.graphData?.data?.[`pivot-grid`];
      let kpiGraphData =
        window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
        window.location.pathname?.split("/")?.[1] === "create-dashboard"
          ? widgetData?.data?.data?.kpi
            ? widgetData?.data?.data?.kpi
            : []
          : widgetData?.graphData?.data?.kpi
          ? widgetData?.graphData?.data?.kpi
          : [];
      let otherGraphData =
        window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
        window.location.pathname?.split("/")?.[1] === "create-dashboard"
          ? widgetData?.data?.data?.[widgetData?.chart?.chart_type]
          : widgetData?.graphData?.data?.[widgetData?.chart?.chart_type]
          ? widgetData?.graphData?.data?.[widgetData?.chart?.chart_type]
          : [];
      const excel = new Excel();
      if (kpiGraphData?.length > 0) {
        if (kpiGraphData?.length > 15) {
          kpiGraphData = kpiGraphData?.slice(0, 15);
        }
        const res = separateColumnsAndData(
          kpiGraphData,
          allAttributes,
          widgetData?.chart?.chart_settings
        );
        excel.addSheet("kpi-sheet");
        res?.forEach((el, ind) => {
          if (el?.columns?.length) {
            excel.addColumns(el.columns);
            excel.addDataSource(el.data, {
              str2Percent: true,
            });
          }
        });
      }
      if (widgetMakerGraphData?.length > 0 || isDeepDive) {
        let columns;
        let updatedDataSource;
        let currentDataSource = isDeepDive
          ? widgetData?.graphData?.data?.pivot_grid?.dataSource
          : widgetMakerGraphData?.[0]?.dataSource?.length
          ? deepCopy(widgetMakerGraphData?.[0]?.dataSource)
          : [];
        if (
          widgetData?.chart?.chart_settings
            ?.show_previous_duration_comparison &&
          !isDeepDive
        ) {
          columns = widgetMakerGraphData[0]?.columns?.map((e) => {
            return {
              title: e.title,
              dataIndex: e.title,
            };
          });
          updatedDataSource = getUpdatedDataSourceForExcel(
            currentDataSource,
            graphConditionConfig
          );
        } else if (
          widgetData?.chart?.chart_settings?.show_previous_duration_data &&
          !isDeepDive
        ) {
          columns = widgetMakerGraphData?.[0]?.columns;
          updatedDataSource = getUpdatedDataSourceForExcel(
            currentDataSource,
            graphConditionConfig
          );
        } else {
          let ColumnsData = isDeepDive
            ? widgetData?.graphData?.data?.pivot_grid?.columns
            : widgetMakerGraphData[0]?.columns;
          // To remove Brand ID column from excel
          if (Array.isArray(ColumnsData) && isDeepDive) {
            ColumnsData = ColumnsData.filter(
              (column) => column.title !== "Brand ID"
            );
          }
          columns = ColumnsData?.map((e) => {
            if (e?.title?.includes("|$|")) {
              let ProfileName = e?.title?.split("|$|")?.[1]?.trim();
              let channelName = e?.title?.split("|$|")?.[0]?.trim();
              return {
                title: channelName + " | " + ProfileName,
                dataIndex: e?.title,
              };
            } else if (e?.title?.includes("|G|")) {
              let genderName = e?.title?.split("|G|")?.[1]?.trim();
              return {
                title: genderName,
                dataIndex: e?.title,
              };
            } else if (e?.title?.includes("|C|")) {
              let countryName = e?.title?.split("|C|")?.[1]?.trim();
              return {
                title: countryName,
                dataIndex: e?.title,
              };
            } else if (e?.title?.includes("|C|")) {
              let countryName = e?.title?.split("|C|")?.[1]?.trim();
              return {
                title: countryName,
                dataIndex: e?.title,
              };
            } else if (
              ColumnsData?.some((column) => column?.children?.length > 0)
            ) {
              return e;
            } else {
              if (
                widgetMakerGraphData?.[0]?.row_span_on &&
                (e?.title === "row_span" || e?.dataIndex === "row_span")
              )
                return null;
              return {
                title: e?.title,
                dataIndex: e?.title,
              };
            }
          })?.filter((el) => el);
          updatedDataSource = getUpdatedDataSourceForExcel(
            currentDataSource,
            graphConditionConfig
          );
          // to handle date formatting in case of ticket TAT or FLR
          if (isDeepDive && updatedDataSource) {
            updatedDataSource = updatedDataSource.map((item) => {
              const updatedItem = { ...item };
              if (typeof updatedItem["Ticket FLR"] === "number") {
                updatedItem["Ticket FLR"] = SecondstoHumanReadable(
                  updatedItem["Ticket FLR"]
                );
              }

              if (typeof updatedItem["Ticket TAT"] === "number") {
                updatedItem["Ticket TAT"] = SecondstoHumanReadable(
                  updatedItem["Ticket TAT"]
                );
              }

              return updatedItem;
            });
          }
        }
        if (columns && widgetData?.graphData?.data?.grid_config) {
          const columnConfig =
            widgetData?.graphData?.data?.grid_config?.columnConfig;
          if (columnConfig && columnConfig?.length > 0) {
            let rearrangedColumns = [];
            for (let configCol of columnConfig) {
              for (let col of columns) {
                if (col?.title === configCol?.title && configCol?.visible) {
                  rearrangedColumns.push(col);
                }
              }
            }
            columns = rearrangedColumns;
          }
        }
        excel
          .addSheet("test")
          .addColumns(columns)
          .addDataSource(updatedDataSource, {
            str2Percent: true,
          });
      }
      if (
        ![
          "grid",
          "pivot-grid",
          "kpi",
          "organization",
          "rich-text",
          "treemap",
        ]?.includes(widgetData?.chart?.chart_type) &&
        (otherGraphData?.length > 0 || Object.keys(otherGraphData)?.length > 0)
      ) {
        let excelData = generateExcelData(
          graphConditionConfig,
          widgetData,
          null,
          allAttributes
        );
        if (excelData?.columns?.length && excelData?.datasource?.length) {
          excel
            .addSheet("chart-sheet")
            .addColumns(excelData?.columns)
            .addDataSource(excelData?.datasource, {
              str2Percent: true,
            });
        }
      }
      excel.saveAs(`${widgetData?.widget_name}.xlsx`);
    }
  };
  return (
    <div className="ml-2">
      <Button
        style={{ height: "3rem" }}
        onClick={handleExport}
        className="text-center btn_Clear"
      >
        <img
          style={{
            width: "1.4rem",
            height: "1.4rem",
            marginRight: "0.5rem",
          }}
          src={excelIcon}
          alt="Excel Icon"
        />
        Export
      </Button>
    </div>
  );
};

export default DownloadExcel;
